export default {
    'Banner列表':'Banner列表',  
    '应用端':'應用端',  
    '位置':'位置',  
    '编辑banner':'編輯banner',  
    '添加图片':'添加圖片',  
    '固定banner':'固定banner',  
    '图片':'圖片',  
    '链接到':'連結到',  
    '链接地址':'連結地址',  
    '上传banner图':'上傳banner圖',  
    '最多只可以同时存在五张轮播图哦！':'最多只可以同時存在五張輪播圖哦！',  
    '取消后，页面数据不再保存':'取消後，頁面數據不再保存',  
    '确认要删除该bannner图吗？':'確認要刪除該bannner圖嗎？',  

    //5.16
    '关闭后，将不在本机构显示此banner':'關閉後，將不在本機構顯示此banner',
    '开启后，将在本机构显示此banner':'開啓後，將在本機構顯示此banner',
    '确认要删除吗':'確認要刪除嗎',
    '发布机构':'發布機構：',
    '开启关闭':'開啓/關閉',
    '不能上移啦':'不能上移啦~',
    '不能下移啦':'不能下移啦~',

}